<template>
	<!-- Main content -->
	<section class="content">
		<div class="row">

			<div class="col-md-12">
				<div class="box box-solid">
					<div class="nav-tabs-custom">
						<ul class="nav nav-tabs">
							<li class="active"><a href="#tab_1" data-toggle="tab"><i class="fa fa-search"></i> Consulta</a></li> 
							<li><a href="#tab_2" data-toggle="tab"><i class="fa fa-history"></i> Histórico</a></li> 
						</ul> 
						<div class="tab-content">
							<div id="tab_1" class="tab-pane active">
								<div class="box-header with-border">
									<label>Entre com os dados: </label>
									<div style="float: right" v-if="resultadoRestritiva != '' || resultadoAnalitica != ''">
										<a class="btn btn-default" @click="reseta"><i class='fa fa-plus'></i> Nova Consulta</a>
									</div>
								</div>

								<div class="box-body">
									<div class="row">
										<div class="col-sm-3">
											<div :class="{'form-group': true }">
												<label for="nome">Tipo de Consulta</label>
												<select :disabled="desabilitados.tipo" class="form-control" name="nome" v-model="tipo_consulta">
													<option value="">--Selecione--</option>
													<option value="DOCUMENTO">DOCUMENTO</option>
													<option value="CHEQUE">CHEQUE</option>
												</select>
											</div>
										</div>

										<div class="col-sm-3">
											<div :class="{'form-group': true }">
												<label for="documento">Documento</label> <small>(CPF ou CNPJ)</small>
												<input :disabled="desabilitados.cpf_cnpj" class="form-control" ref="documento" type="text" v-model="dados.cpf_cnpj" v-mask="['###.###.###-##','##.###.###/####-##']">
											</div>
										</div>

										<div class="col-sm-6">
											<div :class="{'form-group': true }">
												<label for="cmc7">CMC7</label>
												<input :disabled="desabilitados.cmc7" v-model="dados.cmc7" class="form-control" ref="cmc7" type="text" v-mask="['########-##########-############']">
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-sm-12">
											<div class="box-footer text-center">
												<button :disabled="desabilitados.btConsultaRestritiva" class="btn btn-primary" @click="consultar('RESTRITIVA')"><i class='fa fa-search'></i> Consulta Restritiva</button>
												<button :disabled="desabilitados.btConsultaAnalitica" class="btn btn-warning" @click="consultar('ANALÍTICA')"><i class='fa fa-search'></i> Consulta Analítica</button>
												<button :disabled="desabilitados.btConsultaRestritiva" class="btn btn-success" @click="consultar('PROTESTO')"><i class='fa fa-search'></i> Restritiva + Protesto em Cartório</button>
											</div>
										</div>
									</div>
									<div v-if="loading" class="row">
										<div class="col-sm-12">								
											<div style="text-align: center">
												<img :src="loadingGif" />
												<span>Aguarde, processando...</span>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div id="tab_2" class="tab-pane">
							<historico></historico>
							</div>
						</div>
					</div>

					
				</div>
			</div>
		</div>
		<template v-for="com in ordem">
			<resultado-restritiva v-if="resultadoRestritiva != '' && !loading && com == 'restritiva'" :resultado='resultadoRestritiva'></resultado-restritiva>
			<resultado-analitica v-if="resultadoAnalitica != '' && !loading && com == 'analitica'" :resultado='resultadoAnalitica'></resultado-analitica>
		</template>
	</section>

	<!-- /.content -->
</template>



<script>

	import axios from 'axios'
	import {mask} from 'vue-the-mask'
	import Historico from './Historico'

	import ResultadoAnalitica from './ResultadoAnalitica'
	import ResultadoRestritiva from './ResultadoRestritiva'

	export default {
		directives: {mask},
		components: {
			ResultadoAnalitica,
			ResultadoRestritiva,
			Historico
		},
		data() {
			return { 
				ordem: [],
				desabilitados: {
					tipo: false,
					cpf_cnpj: false,
					cmc7: true,
					btConsultaRestritiva: false,
					btConsultaAnalitica: false
				},
				tipo_consulta: '',
				dados: {
					tipo: '',
					cpf_cnpj: '',
					cmc7: ''
				},
				loadingGif:`${this.$store.state.serverURI}/images/carregando.gif`,
				loading: false,
				resultadoRestritiva: [],
				resultadoAnalitica: [],

			}
		},
		mounted() {
	
		},
		methods: {
			reseta() {
				this.dados.tipo = '';
				this.dados.cpf_cnpj = '';
				this.dados.cmc7 = '';
				this.resultadoRestritiva = '';
				this.resultadoAnalitica = '';
				this.ordem = [];
				this.desabilitados.tipo = false;
				this.desabilitados.cpf_cnpj = false;
				this.desabilitados.cmc7 = true;
				this.desabilitados.btConsultaRestritiva = false;
				this.desabilitados.btConsultaAnalitica = false;
			},
			consultar(consulta) {

				this.dados.tipo = consulta;

				if (this.dados.cpf_cnpj == '') {
					let self = this;
					this.$dialog.alert('Por favor, digite um CPF ou CNPJ para realizar a consulta!', {okText: 'Ok'}).then(function() {
						self.$refs.documento.focus();
					});
					return false;
				}

				if (this.dados.tipo == 'CHEQUE') {
					let self = this;
					if (this.dados.cmc7 == '') {
						this.$dialog.alert('Por favor, digite um CMC7 para realizar a consulta!', {okText: 'Ok'}).then(function() {
							self.$refs.cmc7.focus();
						});
					} else if (!this.validaCmc7()) {
						this.$dialog.alert('Por favor, digite um CMC7 válido ou deixe este campo em branco!', {okText: 'Ok'}).then(function() {
							self.$refs.cmc7.focus();
						});
						return false;
					}
				}

				if (!this.validaCpfCnpj()) {
					let self = this;
					this.$dialog.alert('Por favor, digite um CPF ou CNPJ válido!', {okText: 'Ok'}).then(function() {
						self.$refs.documento.focus();
					});
					return false;
				}			

				this.loading = true;
				axios.post(`${this.$store.state.serverURI}/api/consulta/create`, this.dados, this.$store.getters.getHeaderAuth).then(response => {
					this.$store.commit('SHOW_ALERT_SUCCESS');
					var scrollingElement = (document.scrollingElement || document.body);
					if (consulta == 'RESTRITIVA' || consulta == 'PROTESTO') {
						this.resultadoRestritiva = response.data;	
						scrollingElement.scrollTop = 0;
						this.ordem.unshift('restritiva');
					} else if 	(consulta == 'ANALÍTICA') {
						this.resultadoAnalitica = response.data;
						scrollingElement.scrollTop = scrollingElement.scrollHeight;
						this.ordem.unshift('analitica');
					}

					this.loading = false;
				}).catch((error) => {
					this.$store.commit('SHOW_ALERT_ERROR');
					console.log(error);
					this.loading = false;
				});

			},

			validaCpfCnpj() {
				if (this.dados.cpf_cnpj.length == 14) {
					return this.validaCpf();
				} else if (this.dados.cpf_cnpj.length == 18) {
					return this.validaCnpj();
				}
				return false;
			},

			validaCpf() {
				var valor = this.dados.cpf_cnpj;
				valor = valor.toString();
				valor = valor.replace(/[^0-9]/g, '');
				var digitos = valor.substr(0, 9);
				var novoCpf = this.calcDigitosCpf(digitos);
				novoCpf = this.calcDigitosCpf(novoCpf, 11);
				if (novoCpf === valor) {
					return true;
				} 
				return false

			},
			validaCnpj() {
				var valor = this.dados.cpf_cnpj;
				valor = valor.toString();
				valor = valor.replace(/[^0-9]/g, '');
				var cnpjOriginal = valor;
				var primeirosNumerosCnpj = valor.substr(0, 12);
				var primeiroCalculo = this.calcDigitosCnpj(primeirosNumerosCnpj, 5);
				var segundoCalculo = this.calcDigitosCnpj(primeiroCalculo, 6);
				var cnpj = segundoCalculo;
				if (cnpj === cnpjOriginal) {
					return true;
				}
				return false;
			},

			calcDigitosCpf(digitos, posicoes) {
				if (posicoes != 11) {
					posicoes = 10;
				}
				var somaDigitos = 0;
				digitos = digitos.toString();

				for (var i = 0; i<digitos.length; i++) {
					somaDigitos = somaDigitos + (digitos[i] * posicoes);
					posicoes--;
					if (posicoes < 2) {
						posicoes = 9;
					}
				}

				somaDigitos = somaDigitos % 11;
				if (somaDigitos < 2) {
					somaDigitos = 0;
				} else {
					somaDigitos = 11 - somaDigitos;
				}
				var cpf = digitos + somaDigitos;
				return cpf;    
			},

			calcDigitosCnpj(digitos, posicoes) {
				if (posicoes != 5) {
					posicoes = 6;
				}
				var somaDigitos = 0;
				digitos = digitos.toString();

				for (var i = 0; i<digitos.length; i++) {
					somaDigitos = somaDigitos + (digitos[i] * posicoes);
					posicoes--;
					if (posicoes < 2) {
						posicoes = 9;
					}
				}

				somaDigitos = somaDigitos % 11;
				if (somaDigitos < 2) {
					somaDigitos = 0;
				} else {
					somaDigitos = 11 - somaDigitos;
				}
				var cpf = digitos + somaDigitos;
				return cpf;    
			},
			validaCmc7() {

				let cmc7 = this.dados.cmc7;
				let banco = cmc7.substring(0, 3);
				let agencia = cmc7.substring(3, 7);
				let dvdig2 = cmc7.substring(7, 8);
				let comp = cmc7.substring(9, 12);
				let nrCheque = cmc7.substring(12, 18);
				let tipificacao = cmc7.substring(18, 19);
				let dvdig1 = cmc7.substring(20, 21);
				let conta = cmc7.substring(21, 31);
				let dvdig3 = cmc7.substring(31);

				let bloco1 = banco + agencia;
				let bloco2 = comp + nrCheque + tipificacao;
				let bloco3 = conta;

				let dv2 = this.calcularDv2(bloco2);
				let dv1 = this.calcularDv1(bloco1);
				let dv3 = this.calcularDv3(bloco3);

				if (dvdig2 != dv2 || dvdig1 != dv1 || dvdig3 != dv3) {
					return false;
				}

				return true;
			},
			calcularDv2(bloco2) {
				var mult = 1;
				var res = 0;
				var dig = [];

				for (var i = 0; i < 10; i++) {
					if (i < 9) {
						dig[i] = bloco2.substring(i, i + 1) * mult;
					} else {
						dig[i] = bloco2.substring(i) * mult;
					}

					if (dig[i] > 9) {
						dig[i] = '' + dig[i];
						dig[i] = parseInt(dig[i].substring(0, 1)) + parseInt(dig[i].substring(1));
					}

					if (mult == 1) {
						mult = 2;
					} else {
						mult = 1;
					}
				}

				for (i = 0; i < 10; i++) {
					res += dig[i];
				}

				res = res % 10;
				res = 10 - res;

				if (res == 10) {
					res = 0;
				}

				return res;
			},

			calcularDv1(bloco) {
				var mult = 2;
				var res = 0;
				var dig = [];

				for (var i = 0; i < 7; i++) {
					if (i < 6) {
						dig[i] = bloco.substring(i, i + 1) * mult;
					} else {
						dig[i] = bloco.substring(i) * mult;
					}

					if (dig[i] > 9) {
						dig[i] = '' + dig[i];
						dig[i] = parseInt(dig[i].substring(0, 1)) + parseInt(dig[i].substring(1));
					}

					if (mult == 1) {
						mult = 2;
					} else {
						mult = 1;
					}
				}

				for (i = 0; i < 7; i++) {
					res += dig[i];
				}

				res = res % 10;
				res = 10 - res;

				if (res == 10) {
					res = 0;
				}

				return res;
			},

			calcularDv3(bloco3) {
				var mult = 1;
				var res = 0;
				var dig = [];

				for (var i = 0; i < 10; i++) {
					if (i < 9) {
						dig[i] = bloco3.substring(i, i + 1) * mult;
					} else {
						dig[i] = bloco3.substring(i) * mult;
					}

					if (dig[i] > 9) {
						dig[i] = '' + dig[i];
						dig[i] = parseInt(dig[i].substring(0, 1)) + parseInt(dig[i].substring(1));
					}

					if (mult == 1) {
						mult = 2;
					} else {
						mult = 1;
					}
				}

				for (i = 0; i < 10; i++) {
					res += dig[i];
				}

				res = res % 10;
				res = 10 - res;

				if (res == 10) {
					res = 0;
				}
				return res;
			}

		},

		watch: {
			'tipo_consulta': function (value) {
				this.dados.cpf_cnpj = '';
				this.dados.cmc7 = '';
				this.resultadoAnalitica = '';
				this.resultadoRestritiva = '';
				if (value == 'CHEQUE') {
					this.desabilitados.cmc7 = false;
				} else {
					this.desabilitados.cmc7 = true;
				}
				this.$refs.documento.focus();
			},
			resultadoRestritiva: function (value) {
				if (value != '') {
					this.desabilitados.btConsultaRestritiva = true;
					this.desabilitados.tipo = true;
					this.desabilitados.cpf_cnpj = true;
				} else {
					this.desabilitados.btConsultaRestritiva = false;
					this.desabilitados.tipo = false;
					this.desabilitados.cpf_cnpj = false;
				}
			},
			resultadoAnalitica: function (value) {
				if (value != '') {
					this.desabilitados.btConsultaAnalitica = true;
					this.desabilitados.tipo = true;
					this.desabilitados.cpf_cnpj = true;
				} else {
					this.desabilitados.btConsultaAnalitica = false;
					this.desabilitados.tipo = false;
					this.desabilitados.cpf_cnpj = false;
				}
			}
		}
	}
</script>

<style scoped>
	form{
		padding: 0;
	}



</style>



// WEBPACK FOOTER //
// Form.vue?6129d010